export default {
  'TRANSLATION' (state) {
    return state.translation
  },
  'TRANSLATIONS' (state) {
    return state.translations
  },
  'GROUPS' (state) {
    return state.groups
  }
}
